import { B, thDateFull, todayISO, unitCodeList } from './util.js';
import { Pimg } from './ui.jsx';
import { groupLines } from './calc.js';

// ---------- ข้อมูลบริษัท (ตาม reference ทางการ ใช้ทุกแอพ) ----------
export const COMPANY = {
  th: 'บริษัท แคมป์สตูดิโอ (ไทยแลนด์) จำกัด (สำนักงานใหญ่)',
  addr: '412 ซอยสุขุมวิท 71 แขวงพระโขนงเหนือ เขตวัฒนา กรุงเทพมหานคร 10110',
  tel: '02-096-2566', taxId: '0105560181829',
};

export function SheetHead({ sub }) {
  return (
    <div className="sheetlogo">
      <img src="/logo-ink.svg" alt="Camp Studio" />
      <span>{sub || 'CAMP STUDIO'}</span>
      <span style={{ marginLeft: 'auto', fontSize: 9.5, letterSpacing: .3, textTransform: 'none', textAlign: 'right', lineHeight: 1.5 }}>
        {COMPANY.th}<br />{COMPANY.addr}<br />โทร {COMPANY.tel} · เลขผู้เสียภาษี {COMPANY.taxId}
      </span>
    </div>
  );
}

// ---------- ข้อตกลงการเช่า 9 ข้อ ----------
export const TERMS = [
  ['1. รายการอุปกรณ์', 'ผู้เช่าได้ตรวจสอบสภาพและจำนวนอุปกรณ์ครบถ้วนแล้วในวันรับมอบ ผู้ให้เช่าบันทึกภาพถ่ายสภาพอุปกรณ์ทุกชิ้นในวันส่งมอบและวันรับคืน ใช้เป็นหลักฐานประกอบการประเมินความเสียหาย'],
  ['2. ระยะเวลาและค่าเช่า', 'อัตราค่าเช่าฐานคำนวณต่อหนึ่งทริป (2 คืน 3 วัน) เช่าเกินกำหนดคิดเพิ่มคืนละ 35% ของอัตราค่าเช่าต่อทริป ผู้เช่าชำระค่าเช่าและเงินประกันเต็มจำนวนในวันรับมอบ'],
  ['3. เงินประกันความเสียหาย', 'เงินประกันคืนเต็มจำนวนภายใน 7 วันทำการนับจากวันคืนอุปกรณ์ครบถ้วนในสภาพปกติ หลังหักค่าใช้จ่ายตามข้อ 5 และ 6 (ถ้ามี) กรณีกันวงเงินบัตรเครดิต ผู้ให้เช่าจะยกเลิกการกันวงเงินตามกำหนดเดียวกัน'],
  ['4. หน้าที่ของผู้เช่า', 'ใช้อุปกรณ์ตามวัตถุประสงค์ปกติ · ไม่ให้เช่าช่วง ไม่โอนสิทธิ ไม่นำออกนอกราชอาณาจักร · ไม่ใช้เพื่อการค้าเว้นแต่ได้รับความยินยอมเป็นหนังสือ · ไม่ดัดแปลงหรือซ่อมเอง · แจ้งทันทีเมื่อชำรุดหรือสูญหาย · คืนในสภาพสะอาด แห้ง ครบถ้วน ณ สาขาที่รับอุปกรณ์'],
  ['5. การประเมินความเสียหาย', 'ประเมินสภาพในวันรับคืนต่อหน้าผู้เช่า และคิดค่าใช้จ่ายตามตารางค่าเสียหาย หักจากเงินประกัน หากไม่พอผู้เช่าชำระส่วนที่ขาดภายใน 7 วัน ทั้งนี้การสึกหรอตามปกติจากการใช้งานไม่ถือเป็นความเสียหายและไม่มีการเรียกเก็บ'],
  ['6. การคืนล่าช้าและไม่คืนอุปกรณ์', 'คืนล่าช้าคิดค่าปรับวันละ 35% ของอัตราค่าเช่าต่อทริป · ไม่คืนเกิน 7 วันนับจากกำหนดคืนและไม่ติดต่อ ให้ถือว่าผู้เช่าประสงค์ซื้ออุปกรณ์นั้นในราคาจำหน่ายปลีก ณ วันทำสัญญา'],
  ['7. เครดิตค่าเช่าเพื่อซื้อสินค้า', 'ผู้เช่าได้รับเครดิตเท่ากับค่าเช่าทริปแรกของอุปกรณ์แต่ละชิ้น ใช้เป็นส่วนลดซื้อรุ่นเดียวกันหรือใกล้เคียง อายุ 15 วันนับจากวันคืนอุปกรณ์ ใช้ได้เฉพาะผู้เช่าตามสัญญานี้ โอนสิทธิหรือแลกเป็นเงินสดไม่ได้'],
  ['8. ข้อมูลส่วนบุคคล', 'ผู้เช่ายินยอมให้จัดเก็บสำเนาเอกสารยืนยันตัวตนและข้อมูลติดต่อ เพื่อยืนยันตัวตนและติดตามทรัพย์สินเท่านั้น จัดเก็บด้วยการเข้ารหัส จำกัดสิทธิ์เข้าถึง บันทึกประวัติการเข้าถึงทุกครั้ง และลบภายใน 90 วันนับจากปิดสัญญา ผู้เช่ามีสิทธิขอเข้าถึง แก้ไข หรือขอให้ลบข้อมูลตาม พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562'],
  ['9. ข้อตกลงทั่วไป', 'อุปกรณ์เป็นกรรมสิทธิ์ของผู้ให้เช่าตลอดระยะเวลาเช่า · ผู้ให้เช่าไม่รับผิดต่อความเสียหายจากการใช้อุปกรณ์ เว้นแต่เกิดจากความชำรุดที่ผู้ให้เช่าทราบอยู่แล้วและมิได้แจ้ง · ข้อพิพาทให้เจรจาโดยสุจริตก่อน · อยู่ภายใต้บังคับกฎหมายไทย'],
];

export const DMG = [
  ['ปกติ', 'ใช้งานตามปกติ มีร่องรอยทั่วไป', 'ไม่มี'],
  ['สกปรกมาก', 'ต้องทำความสะอาดเป็นพิเศษ', '200 – 500 บาท/ชิ้น'],
  ['ซ่อมได้', 'ชำรุดแต่ซ่อมคืนสภาพได้', 'ตามจริง ไม่เกิน 30% ของราคาจำหน่ายปลีก'],
  ['ใช้งานไม่ได้ / สูญหาย', 'เสียหายจนใช้ไม่ได้ ขาดชิ้นส่วน หรือสูญหาย', '60% ของราคาจำหน่ายปลีก'],
];

// ---------- ข้อตกลงการเช่าฉบับเต็ม ----------
export function TermsSheet() {
  return (<>
    <SheetHead />
    <h1>ข้อตกลงการเช่าอุปกรณ์</h1>
    <div className="rule" />
    <div className="terms">
      {TERMS.map(t => <div key={t[0]} style={{ marginBottom: 11 }}><b>{t[0]}</b><br />{t[1]}</div>)}
    </div>
    <h4>ตารางค่าเสียหาย</h4>
    <table><thead><tr><th>ระดับ</th><th>ลักษณะ</th><th>ค่าใช้จ่าย</th></tr></thead>
      <tbody>{DMG.map(d => <tr key={d[0]}><td>{d[0]}</td><td>{d[1]}</td><td>{d[2]}</td></tr>)}</tbody></table>
  </>);
}

// ---------- ใบเช่าอุปกรณ์ ----------
// contract: ข้อมูลจากฟอร์ม (ยังไม่บันทึก) หรือจากสัญญาจริง
export function ContractSheet({ no, customer, entity, tier, nights, fromDate, toDate, calc, idDocCount, idType, branchName }) {
  const isCo = entity === 'company';
  const who = isCo ? (customer.company || '—') : `${customer.first_name || ''} ${customer.last_name || ''}`.trim() || '—';
  // รุ่นเดียวกันรวมเป็นบรรทัดเดียว + คอลัมน์จำนวน — เช่าเก้าอี้ 6 ตัวใบยังจบใน 1 หน้า
  const rows = groupLines(calc.lines);
  return (<>
    <SheetHead sub={branchName} />
    <h1>ใบเช่าอุปกรณ์</h1>
    <div style={{ fontSize: 11, color: '#8a8a8a', letterSpacing: 1 }}>EQUIPMENT RENTAL NOTE</div>
    <div className="rule" />
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 26 }}>
      <div>
        <h4>ผู้เช่า</h4>
        <div className="kv">
          <b>{isCo ? 'ชื่อนิติบุคคล' : 'ชื่อ-นามสกุล'}</b><span>{who}</span>
          {isCo && (<>
            <b>เลขผู้เสียภาษี</b><span className="mono">{customer.tax_id || '—'}</span>
            <b>สำนักงาน</b><span>{customer.tax_branch || 'สำนักงานใหญ่'}</span>
            <b>ผู้ติดต่อ</b><span>{customer.contact || '—'}</span>
          </>)}
          <b>โทรศัพท์</b><span className="mono">{customer.phone || '—'}</span>
          <b>อีเมล</b><span>{customer.email || '—'}</span>
          <b>LINE</b><span>{customer.line_id || '—'}</span>
          <b>ที่อยู่</b><span>{customer.address || '—'}</span>
          <b>เอกสารยืนยัน</b><span>{idType} (แนบ {idDocCount} ไฟล์)</span>
        </div>
      </div>
      <div>
        <h4>สัญญา</h4>
        <div className="kv">
          <b>เลขที่สัญญา</b><span className="mono">{no}</span>
          <b>วันที่ทำสัญญา</b><span>{thDateFull(fromDate)}</span>
          <b>ระยะเวลาเช่า</b><span>{nights} คืน</span>
          <b>กำหนดคืน</b><span>{thDateFull(toDate)}</span>
          <b>ระดับผู้เช่า</b><span>{tier.name}</span>
          <b>ประเภทผู้เช่า</b><span>{isCo ? 'นิติบุคคล' : 'บุคคลธรรมดา'}</span>
        </div>
      </div>
    </div>

    <h4>รายการอุปกรณ์ที่เช่า ({calc.lines.length} ชิ้น{rows.length !== calc.lines.length ? ` · ${rows.length} รุ่น` : ''})</h4>
    <table className="itemtbl">
      <thead><tr><th className="ipic"></th><th>สินค้า</th><th className="isku">SKU · ชิ้นที่ส่งมอบ</th><th className="iqty">จำนวน</th><th className="inum">ราคาป้าย/ชิ้น</th><th className="inum">ค่าเช่า</th><th className="inum">เงินประกัน</th></tr></thead>
      <tbody>
        {rows.map((l, i) => (
          <tr key={i}>
            <td className="ipic"><Pimg cat={l.category} size={26} image={l.image_url} /></td>
            <td>{l.name}</td>
            <td className="mono isku">{l.sku}{l.unit_codes?.length ? ' · ' + unitCodeList(l.unit_codes) : ''}</td>
            <td className="mono iqty">{l.qty}</td>
            <td className="mono inum">{B(l.retail)}</td>
            <td className="mono inum">{Number(tier.rent_mul) === 0 ? 'ยกเว้น' : B(l.rent)}</td>
            <td className="mono inum">{B(l.deposit)}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div style={{ fontSize: 11, color: '#8a8a8a', marginTop: 6 }}>ราคาป้ายใช้เป็นฐานคำนวณค่าเสียหายตามข้อ 5 โดยยึดราคา ณ วันทำสัญญานี้ · ช่องค่าเช่าและเงินประกันเป็นยอดรวมของจำนวนในบรรทัดนั้น</div>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 30, marginTop: 22 }}>
      <div>
        <h4>สรุปการชำระเงิน</h4>
        <div className="tot"><span>ค่าเช่ารวม{Number(tier.rent_mul) !== 1 ? ` (×${tier.rent_mul})` : ''}</span><span className="mono">{Number(tier.rent_mul) === 0 ? 'ยกเว้น' : B(calc.gross)}</span></div>
        {calc.volAmt > 0 && <div className="tot"><span>ส่วนลดปริมาณ {calc.vol.label}</span><span className="mono">−{B(calc.volAmt)}</span></div>}
        {calc.net > 0 && (<>
          <div className="tot"><span>มูลค่าก่อน VAT</span><span className="mono">{B(calc.exVat)}</span></div>
          <div className="tot"><span>ภาษีมูลค่าเพิ่ม {Math.round((calc.net / calc.exVat - 1) * 100) || 7}%</span><span className="mono">{B(calc.vat)}</span></div>
        </>)}
        {calc.wht > 0 && <div className="tot"><span>หักภาษี ณ ที่จ่าย 5%</span><span className="mono">−{B(calc.wht)}</span></div>}
        <div className="tot"><span>เงินประกันความเสียหาย</span><span className="mono">{B(calc.dep)}</span></div>
        <div className="tot big"><span>รับเงินวันนี้</span><span className="mono">{B(calc.cash)} ฿</span></div>
        {calc.wht > 0 && <div style={{ fontSize: 11, color: '#8a8a8a', marginTop: 8 }}>ผู้เช่าโปรดออกหนังสือรับรองการหักภาษี ณ ที่จ่ายให้ผู้ให้เช่า · เงินประกันไม่อยู่ในฐานหักภาษี ณ ที่จ่าย</div>}
        {tier.key === 'inf' && <div style={{ fontSize: 11, color: '#8a8a8a', marginTop: 8 }}>ยกเว้นค่าเช่าตามข้อตกลงคอนเทนต์แนบท้าย · ผู้เช่ายังต้องวางเงินประกันตามปกติ</div>}
        <div style={{ fontSize: 11, color: '#8a8a8a', marginTop: 8 }}>เงินประกันเป็นเงินรับฝากที่ต้องคืน ไม่ใช่รายได้ค่าบริการ — ใบรับเงินประกันไม่ใช่ใบกำกับภาษี</div>
      </div>
      <div>
        <h4>ตารางค่าเสียหาย</h4>
        <table><tbody>{DMG.map(d => <tr key={d[0]}><td style={{ width: '34%' }}><b>{d[0]}</b></td><td>{d[2]}</td></tr>)}</tbody></table>
        <div style={{ fontSize: 11, color: '#8a8a8a', marginTop: 6 }}>การสึกหรอตามปกติไม่ถือเป็นความเสียหาย</div>
      </div>
    </div>

    <h4>ข้อตกลงการเช่า</h4>
    <div className="terms">
      <ol style={{ paddingLeft: 16, margin: 0 }}>
        {TERMS.map(t => <li key={t[0]}><b>{t[0].replace(/^\d+\.\s*/, '')}</b> — {t[1]}</li>)}
      </ol>
    </div>

    <div className="sign">
      <div><div className="sigline" />ลงชื่อผู้เช่า<br />( {who !== '—' ? who : ' '.repeat(20)} )<br />วันที่ {thDateFull(fromDate)}</div>
      <div><div className="sigline" />ลงชื่อผู้ให้เช่า / พนักงาน<br />(   )<br />{COMPANY.th.replace(' (สำนักงานใหญ่)', '')}</div>
    </div>
  </>);
}

// ---------- ใบใช้เครดิตเช่า→ซื้อ ----------
export function CreditSheet({ credit, price, applied, forfeited, net, exVat, vat, branchName }) {
  return (<>
    <SheetHead sub={branchName} />
    <h1>ใบใช้เครดิตเช่าเพื่อซื้อ</h1>
    <div style={{ fontSize: 11, color: '#8a8a8a', letterSpacing: 1 }}>RENT-TO-BUY CREDIT REDEMPTION</div>
    <div className="rule" />
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 26 }}>
      <div>
        <h4>ลูกค้า</h4>
        <div className="kv">
          <b>ชื่อ</b><span>{credit.customer_name}</span>
          <b>เครดิตคงเหลือ</b><span className="mono">{B(credit.amount)} ฿</span>
          <b>อายุคงเหลือ</b><span className="mono">{credit.days_left} วัน</span>
          <b>จากสัญญา</b><span className="mono">{credit.contract_no || '—'}</span>
        </div>
      </div>
      <div>
        <h4>สินค้าที่ซื้อ</h4>
        <div className="kv">
          <b>สินค้า</b><span>{credit.name_snapshot}</span>
          <b>SKU</b><span className="mono">{credit.sku}</span>
          <b>ราคาป้าย</b><span className="mono">{B(price)} ฿</span>
        </div>
      </div>
    </div>

    <h4>การคำนวณ</h4>
    <div style={{ maxWidth: 420 }}>
      <div className="tot"><span>ราคาสินค้า (รวม VAT)</span><span className="mono">{B(price)}</span></div>
      <div className="tot"><span>หักเครดิตค่าเช่า</span><span className="mono">−{B(applied)}</span></div>
      <div className="tot"><span>ยอดสุทธิ</span><span className="mono">{B(net)}</span></div>
      <div className="tot"><span>&nbsp;&nbsp;มูลค่าก่อน VAT</span><span className="mono">{B(exVat)}</span></div>
      <div className="tot"><span>&nbsp;&nbsp;VAT</span><span className="mono">{B(vat)}</span></div>
      <div className="tot big"><span>ลูกค้าชำระ</span><span className="mono">{B(net)} ฿</span></div>
    </div>
    {forfeited > 0 && <div className="warnbox">เครดิตส่วนที่เกินราคาสินค้า {B(forfeited)} ฿ จะถูกตัดทิ้ง ไม่ทอนเป็นเงินสดและไม่เก็บไว้ใช้ครั้งถัดไป</div>}

    <h4>เงื่อนไขที่ระบบบังคับ</h4>
    <div className="terms">
      <ul style={{ paddingLeft: 16, margin: 0 }}>
        <li>ใช้ได้เฉพาะสินค้า SKU <b>{credit.sku}</b> เท่านั้น ไม่สามารถใช้กับสินค้าอื่น</li>
        <li>ใช้ครั้งเดียวจบ ส่วนที่เหลือไม่เก็บไว้ใช้ครั้งถัดไป และไม่ทอนเป็นเงินสด</li>
        <li>ใช้ร่วมกับส่วนลดรายการอื่นไม่ได้ และใช้ร่วมกับการรับเทิร์นไม่ได้</li>
        <li>VAT คำนวณจากยอดหลังหักส่วนลด และแสดงบรรทัดส่วนลดบนใบกำกับภาษี</li>
        <li>กรณีขอคืนเงิน คืนเฉพาะยอดเงินสดที่ชำระจริง <b>{B(net)} ฿</b> ไม่คืนส่วนที่เป็นเครดิต</li>
      </ul>
    </div>

    <div className="sign">
      <div><div className="sigline" />ลงชื่อลูกค้า<br />( {credit.customer_name} )</div>
      <div><div className="sigline" />ลงชื่อพนักงาน<br />(   )</div>
    </div>
  </>);
}

// ---------- ใบรับเงินประกัน (ไม่ใช่ใบกำกับภาษี) ----------
export function DepositReceiptSheet({ no, customerName, amount, method, branchName }) {
  const methodTh = { cash: 'เงินสด', transfer: 'โอนเข้าบัญชี', preauth: 'กันวงเงินบัตรเครดิต' }[method] || method;
  return (<>
    <SheetHead sub={branchName} />
    <h1>ใบรับเงินประกัน</h1>
    <div style={{ fontSize: 11, color: '#8a8a8a', letterSpacing: 1 }}>SECURITY DEPOSIT RECEIPT</div>
    <div className="notax">เอกสารนี้ไม่ใช่ใบกำกับภาษี</div>
    <div className="rule" />
    <div className="kv" style={{ maxWidth: 460 }}>
      <b>อ้างอิงสัญญา</b><span className="mono">{no}</span>
      <b>วันที่</b><span>{thDateFull(todayISO())}</span>
      <b>รับจาก</b><span>{customerName}</span>
      <b>วิธีรับ</b><span>{methodTh}</span>
      <b>จำนวนเงิน</b><span className="mono" style={{ fontWeight: 800, fontSize: 16 }}>{B(amount)} ฿</span>
    </div>
    <div className="warnbox" style={{ marginTop: 18 }}>
      เงินประกันความเสียหายเป็นเงินรับฝากที่ผู้ให้เช่าต้องคืนตามเงื่อนไขข้อ 3 ของข้อตกลงการเช่า
      ไม่ใช่รายได้ค่าสินค้าหรือบริการ จึงไม่มีภาษีมูลค่าเพิ่มและไม่ออกใบกำกับภาษีสำหรับรายการนี้
    </div>
    <div className="sign">
      <div><div className="sigline" />ลงชื่อผู้วางเงินประกัน<br />( {customerName} )</div>
      <div><div className="sigline" />ลงชื่อพนักงานผู้รับเงิน<br />(   )</div>
    </div>
  </>);
}
